import React from 'react';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../../../../../../store/types';
import { REDUX_STORE_SLICES } from '../../../../../../../services/exports/Constants';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useModalRouter from '../../../../../common/hooks/useModalRouter';
import { Modals } from '../../../../../exports/Enums';
import GiftCardIcon from '../../../../../../../assets/logo/GiftCardIcon';

const BuyGiftCards = () => {
  const companyName = useSelector((store: StoreInterface) => store[REDUX_STORE_SLICES.INITIAL_DATA].company.name);
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Home:Components:BuyGiftCards' });
  const isGiftCardEnabled = useSelector((state: StoreInterface) => state.initialData.franchise?.is_gift_cards_enabled);
  const { openModal } = useModalRouter();

  if (!isGiftCardEnabled) {
    return null;
  }

  const onClick = () =>
    openModal({
      id: Modals.BuyGiftCardModal,
    });

  return (
    <div className="px-md mt-md">
      <div className="rounded-xl shadow-section overflow-hidden">
        <div className="h-40 flex justify-center size-full bg-brand-primary/75">
          <GiftCardIcon className="text-white p-md aspect-square object-cover w-2/3" />
        </div>
        <div className="p-4">
          <h4 className="font-bold text-base">{t('title')}</h4>
          <p className="font-medium text-sm text-muted-foreground mt-1">{t('subtitle', { companyName })}</p>
          <Button
            onClick={onClick}
            className="!mt-3 !bg-brand-primary !text-white !p-3 !rounded-full !font-normal !text-base !min-w-40 !capitalize"
          >
            {t('buttons.buy_now')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BuyGiftCards;
